// Generouted, changes to this file will be overriden
/* eslint-disable */

import { components, hooks, utils } from '@generouted/react-router/client'

export type Path =
  | `/`
  | `/access-denied`
  | `/audit-logs`
  | `/reports`
  | `/reports/exam-course-analysis`
  | `/reports/exam-event-overview`
  | `/reports/qbank-items-analysis`
  | `/reports/qbank-items-analysis-yearly`
  | `/reports/qset-usage`
  | `/reports/question-usage-by-qset`
  | `/reports/questionnaire`
  | `/user-not-active`

export type Params = {
  
}

export type ModalPath = never

export const { Link, Navigate } = components<Path, Params>()
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>()
export const { redirect } = utils<Path, Params>()
